import styled from 'styled-components'

export const FormItemContainer = styled.div`
  min-height: 58px;
  position: relative;
  /* .ant-form-item-explain, .ant-form-item-extra {
    font-size: 12px;
  } */
`
